module.exports = __webpack_public_path__ + "static/img/indexbg2.9f08b73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/indexbg2.jpg
// module id = nim2
// module chunks = 1